import ReactApexChart from 'react-apexcharts';

export default function RegistrationTimelineChart({ series, options }) {
  return (
    <ReactApexChart
      className='h-full w-full'
      type={options?.chart?.type ?? 'line'}
      series={series}
      options={options}
      height='100%'
    />
  );
}
